import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BACKEND_URLS, BackendUrls } from 'app/app.config';

export interface IRating
{
  document: string
  rating: number
  option: number
  comment: string
}

@Injectable({
  providedIn: 'root',
})
export class RatingService {




  constructor(
    @Inject(BACKEND_URLS) private backendUrls: BackendUrls,
    private _httpClient: HttpClient,
  ) {}

    createRating(data:IRating): Observable<IRating> {
        return this._httpClient.post(`${this.backendUrls.backendApiUrl}/rating`, data)
            .pipe(
                map((ret: IRating)=>{

                  return ret

                })
            );
      }

}
